import { render, staticRenderFns } from "./showliquidacion.vue?vue&type=template&id=1b807bd8"
import script from "./showliquidacion.vue?vue&type=script&lang=js"
export * from "./showliquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports